export default class DealerStore {

  static PAYMENT_METHOD_TYPE_CARD = 1;
  static PAYMENT_METHOD_TYPE_BANK_ACCOUNT = 2;
  static PAYMENT_METHOD_TYPE_CHECK = 3;

  static INDENMITY_STATUS_REJECTED = -1;
  static INDENMITY_STATUS_PENDING = 0;
  static INDENMITY_STATUS_APPROVED = 1;

  static US_REGION_ALL = 1;
  static US_REGION_WEST = 2;
  static US_REGION_CENTRAL = 3;
  static US_REGION_EAST = 4;

  static getUsRegionMap() {
    return {
      [this.US_REGION_ALL]: 'All',
      [this.US_REGION_WEST]: 'West',
      [this.US_REGION_CENTRAL]: 'Central',
      [this.US_REGION_EAST]: 'East',
    };
  }

  static getUsRegionName(id) {
    return this.getUsRegionMap()[id];
  }

  static getPaymentMethodMap() {
    return {
      [this.PAYMENT_METHOD_TYPE_CARD]: 'Card',
      [this.PAYMENT_METHOD_TYPE_BANK_ACCOUNT]: 'Bank Account',
      [this.PAYMENT_METHOD_TYPE_CHECK]: 'Check',
    };
  }

  static getPaymentMethodName(id) {
    return this.getPaymentMethodMap()[id];
  }

  static isStripePaymentMethod(paymentMethodType) {
    return [this.PAYMENT_METHOD_TYPE_CARD, this.PAYMENT_METHOD_TYPE_BANK_ACCOUNT].includes(paymentMethodType);
  }

  static isOfflinePaymentMethod(paymentMethodType) {
    return [this.PAYMENT_METHOD_TYPE_CHECK].includes(paymentMethodType);
  }

  static getIndemnityStatusMap() {
    return {
      [this.INDENMITY_STATUS_REJECTED]: 'Rejected',
      [this.INDENMITY_STATUS_PENDING]: 'Pending',
      [this.INDENMITY_STATUS_APPROVED]: 'Approved',
    };
  }

  static getIndemnityStatusColor(status) {
    switch (status) {
      case this.INDENMITY_STATUS_REJECTED:
        return 'text-danger';
      case this.INDENMITY_STATUS_PENDING:
        return 'text-warning';
      case this.INDENMITY_STATUS_APPROVED:
        return 'text-success';
    }
  }
}